<template>
    <q-no-ssr>
        <div class="row container-global" style="padding-top : 98px">
            <div class="col-12 col-md-3">
                <div class="box-type-helpers q-ma-md q-pa-sm">
                    <div class="cursor-pointer q-pa-sm q-my-sm fs-md " @click="changeBox(1)"
                        :class="{ 'active': boxShow == 1 }">التقييم العام</div>
                    <div class="cursor-pointer q-pa-sm q-my-sm fs-md" @click="changeBox(2)"
                        :class="{ 'active': boxShow == 2 }">المقيم المعتمـد</div>
                    <div class="cursor-pointer q-pa-sm q-my-sm fs-md" @click="changeBox(3)"
                        :class="{ 'active': boxShow == 3 }">طلب تقييم موقع</div>
                </div>
            </div>
            <div class="col-12 col-md-9">
                <div class="box-content-helpers q-ma-md q-pa-md">
                    <div class="q-pa-sm" v-if="boxShow == 1">
                        <h2 class="text-primary fs-4 text-weight-bold">
                            خطوات استخدام أداة أكواد في التقييم العام
                        </h2>
                        <h3 class="title">
                            أولًا : حمّل أداة أكواد
                        </h3>
                        <p class="desc">
                            انتقل إلى .
                            Google Web Store
                            وقم بتثبيت أداة Akwad Ux Tool على المتصفح
                        </p>
                        <div class="container-img" style=" width: 50%;min-width: 360px;max-width: 700px;">
                            <img src="@/assets/images/help/help-1-1.png" alt="صورة مساعدة رقم واحد">
                        </div>
                        <br />

                        <h3 class="title">
                            ثانيًا : افتح أداة أكواد
                        </h3>
                        <p class="desc">
                            من أيقونة الإضافات قم بفتح أداة أكواد وتثبيتها لسهولة الوصول لها في كل مرة
                        </p>
                        <div class="container-img" style="    width: 300px">
                            <img src="@/assets/images/help/help-1-2.png" alt="صورة مساعدة رقم اثنين">
                        </div>
                        <br />

                        <h3 class="title">
                            ثالثًا : سجّل حسابك
                        </h3>
                        <p class="desc">
                            سجّل حسابك في أكواد من خلال تسجيل الدخول أو مستخدم جديد ، كما يمكنك البدء في التقييم
                            ومن ثم التسجيل
                        </p>
                        <div class="container-img" style="    width: 240px">
                            <img src="@/assets/images/help/help-1-3.png" alt="صورة مساعدة رقم ثلاثة">
                        </div>
                        <br />

                        <h3 class="title">
                            رابعًا : ابدأ التقييم
                        </h3>
                        <p class="desc row items-center">
                            من خلال أيقونة
                            <span class="q-mx-sm q-mt-sm">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M13.7282 3.44375L15.4882 6.99275C15.7282 7.48675 16.3682 7.96075 16.9082 8.05075L20.0972 8.58575C22.1372 8.92875 22.6172 10.4207 21.1472 11.8927L18.6672 14.3927C18.2472 14.8157 18.0172 15.6328 18.1472 16.2178L18.8572 19.3127C19.4172 21.7627 18.1272 22.7098 15.9772 21.4298L12.9872 19.6448C12.4472 19.3228 11.5572 19.3228 11.0072 19.6448L8.01919 21.4298C5.87919 22.7098 4.57919 21.7517 5.13919 19.3127L5.84919 16.2178C5.97919 15.6328 5.74919 14.8157 5.32919 14.3927L2.84919 11.8927C1.39019 10.4197 1.86019 8.92875 3.89919 8.58575L7.08919 8.05075C7.61919 7.96075 8.25919 7.48675 8.49919 6.99275L10.2592 3.44375C11.2192 1.51875 12.7792 1.51875 13.7292 3.44375"
                                        stroke="#5854FF" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </span>
                            يمكنك البدء في تقييم تجربتك للمواقع والخدمات الرقمية
                        </p>
                        <div class="container-img" style="    width: 240px">
                            <img src="@/assets/images/help/help-1-4.png" alt="صورة مساعدة رقم اربعة">
                        </div>
                        <br />

                    </div>
                    <div class="q-pa-sm" v-if="boxShow == 2">

                        <h2 class="text-primary fs-4 text-weight-bold">
                            خطوات استخدام أداة أكواد كمقيم معتمد </h2>
                        <p class="desc">
                            حتى تكون مقيمًا معتمدًا في أكواد ، لابد من وجود 10 تقييمات في نفس تخصصك
                            الذي ترغب بالتقييم من خلاله ، ولابد أن تتصف هذه التقــــــييمات بـــــــجودة عـــــالية
                            و تكون ذات قيمة حقيقية ، بعدها يمكنك التقديم على نموذج المقيم العتمـــــد.
                        </p>
                        <br />

                        <h3 class="title">
                            أولًا : التقديم على نموذج الانضمام للمقيم المعتمد
                        </h3>
                        <p class="desc">
                            بعد تقديمك لعشرة تقييمات وقبولها من قِبل مدققين أكواد ، يمكنك الآن التقديم
                            على نموذج المقيم المعتمد من خلال القائمة المنسدلة ، أختر انضم كمقيم معتمد
                        </p>
                        <div class="container-img" style="    width: 240px">
                            <img src="@/assets/images/help/help-2-1.png" alt="صورة مساعدة رقم واحد">
                        </div>
                        <p>
                            أو من خلال الانتقال إلى :
                        </p>
                        <div class="container-img" style=" width: 180px; ">
                            <img src="@/assets/images/help/help-2-2.png" alt="صورة مساعدة رقم 2">
                        </div>
                        <div class="container-img" style="  width: 50%;min-width: 360px;max-width: 700px; ">
                            <img src="@/assets/images/help/help-2-3.png" alt="صورة مساعدة رقم 3">
                        </div>
                        <br />
                        <h3 class="title">
                            ثانيًا : تعبئة النموذج
                        </h3>
                        <p class="desc">
                            ابدأ بإضافة معلوماتك مع الأنتباه لإختيار تخصصك الذي تود أن تستقبل من خلاله طلبات تقييم
                            المواقع
                            كما يمكنك التعديل على هذه البيانات لاحقًا </p>

                        <div class="container-img column items-center justify-center" style=" width: 300px; ">
                            <img src="@/assets/images/help/help-2-4-1.png" alt="صورة مساعدة رقم 4">
                            <!-- <img src="@/assets/images/help/help-2-5.png" alt="صورة مساعدة رقم 5"> -->
                        </div>
                    </div>
                    <div class="q-pa-sm" v-if="boxShow == 3">
                        <h2 class="text-primary fs-4 text-weight-bold">
                            خطوات استخدام أكواد لطلب تقييم موقع</h2>

                        <h3 class="title">
                            أولًا : طلب رأي خبير
                        </h3>
                        <p class="desc">
                            يمكنك قياس أداء موقعك وتحسين تجربته الرقمية عن طريق طلب تقييم لموقعك من قِبل خبراء أكواد
                            من خلال : </p>
                        <div class="container-img" style="    width: 240px">
                            <img src="@/assets/images/help/help-3-1.png" alt="صورة مساعدة رقم واحد">
                        </div>
                        <div class="container-img" style=" width: 50%;min-width: 360px;max-width: 700px;">
                            <img src="@/assets/images/help/help-3-2.png" alt="صورة مساعدة رقم 2">
                        </div>
                        <br />

                        <h3 class="title">
                            ثانيًا : التقديم على نموذج تقييم الموقع
                        </h3>
                        <p class="desc">
                            ابدأ بتعبئة النموذج ، بما يناسب احتياجاتك وماتحتاج لإختباره 
                        </p>
                        <div class="container-img" style="    width: 300px">
                            <img src="@/assets/images/help/help-3-3.png" alt="صورة مساعدة رقم 3">
                        </div>
                        <br />
                        <h3 class="title">
                            ثالثًا : ارسال الطلب
                        </h3>
                        <p class="desc">
                            بعد ارسالك للطلب ، أكمل عملية الدفع حتى يتم الموافقة على الطلب والبدء بتنفيذه
                        </p>
                        <div class="container-img" style="    width: 320px">
                            <img src="@/assets/images/help/help-3-4.png" alt="صورة مساعدة رقم 4">
                        </div>
                        <br />
                        <h3 class="title">
                            رابعًا : متابعة حالة الطلب
                        </h3>
                        <p class="desc">
                            بعد إتمام الدفع يمكنك متابعة حالة الطلب من خلال الطلبات ، ومعرفة الحالات التي يمر بها الطلب
                        </p>
                        <div class="container-img" style="  width: 50%;min-width: 360px;max-width: 700px;">
                            <span>
                                <img src="@/assets/images/help/help-3-5.png" alt="صورة مساعدة رقم 5" width="200px">

                            </span>
                            <img src="@/assets/images/help/help-3-6.png" alt="صورة مساعدة رقم 6">
                        </div>
                        <br />
                    </div>
                </div>
            </div>
        </div>
    </q-no-ssr>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const boxShow = ref(1);


const changeBox = (box: number) => {
    boxShow.value = box;
}
</script>

<style scoped lang="scss">
.box-type-helpers {
    border: 1px solid #ddd;
    border-radius: 8px;

    >div {
        transition: .2s;
        border-radius: 4px;

        &:hover,
        &.active {
            background: #f0f0f0;
        }
    }
}

.box-content-helpers {
    border: 1px solid #ddd;
    border-radius: 8px;
    min-height: 100vh;
}

.title {
    font-size: var(--fs-5);
    font-weight: 500;
    margin-block: 16px;
}

.desc {
    font-size: var(--fs-md);
    color: #848C93;
    max-width: 520px;
}

.container-img {
    border-radius: 12px;
    border: 2px solid #ddd;
    padding: 20px;
    margin-block: 20px;

    >img {
        border-radius: 12px;
        width: 100%;
    }
}
</style>
